import { IComponentOptions, IController, IScope } from 'angular';
import { TransitionBarService } from './transition-bar.service';
import './transition-bar.component.scss';

export class TransitionProgressController implements IController {
  static $inject = [
    '$scope',
    'TransitionBarService'
  ];
  active = false;
  screen = null;

  constructor(private $scope: IScope,
    private transitionBarService: TransitionBarService) {
  }

  $onInit() {
    this.transitionBarService.getState()
      .subscribe((isActive) => {
        this.active = isActive;
      });
    // this.screen = this.isScreenResolution();
  }


  // isScreenResolution(): string {
  //   console.log("screen resolution in transition-bar - ", screen.width);
  //   let myScreen: number = screen.width;
  //   if (myScreen > 1200) {
  //     return "states";
  //   } else {
  //     return "states_mobile"
  //   }
  // }

}

export const TransitionBarComponent: IComponentOptions = {
  controller: TransitionProgressController,
  template: require('./transition-bar.component.html')
};



// WEBPACK FOOTER //
// ./app/ui/transition-bar/transition-bar.component.ts